<template>
  <section class="upload-media-modal">
    <div class="upload-container">
      <div class="upload-container__header">
        <div class="upload-container__header__wrapper"></div>
        <h2>UPLOAD IMAGES</h2>
        <div
          class="upload-container__header__wrapper"
          @click="closeUploadMedia"
        >
          <img src="@/assets/EndOfLife/closeIconDark.svg" alt="Close Icon" />
        </div>
      </div>
      <input
        type="file"
        style="display: none"
        ref="fileInput"
        accept="images/*"
        multiple
        @change="onFileSelected"
      />
      <!-- Step 1: Select File -->
      <div v-if="uploadStage == 'SELECT_FILE'">
        <div
          class="upload-container__upload-box"
          @click="selectFile"
          @dragenter.prevent="dragNDropHighlight"
          @dragleave.prevent="dragNDropUnHighlight"
          @dragover.prevent="dragNDropHighlight"
          @drop.prevent="onFileDropped"
        >
          <v-icon
            name="cloud-upload-alt"
            scale="8"
            color="#48B9BA"
            style="align-self: center"
          ></v-icon>
          <h3>DRAG &amp; DROP IMAGES HERE</h3>
          <p>OR<span>CLICK HERE TO SELECT IMAGES</span></p>
        </div>
      </div>
      <!-- Step 2: Selected File -->
      <div v-else-if="uploadStage == 'SELECTED_FILE'">
        <div
          class="upload-container__upload-box"
          @click="selectFile"
          @dragenter.prevent="dragNDropHighlight"
          @dragleave.prevent="dragNDropUnHighlight"
          @dragover.prevent="dragNDropHighlight"
          @drop.prevent="onFileDropped"
        >
          <v-icon
            name="cloud-upload-alt"
            scale="8"
            color="#48B9BA"
            style="align-self: center"
          ></v-icon>
          <h3>SELECTED IMAGES:</h3>
          <div>
            <span v-for="item in imageFile" :key="item.id">
              {{ item.name }},
            </span>
          </div>
          <p><br /><span>CLICK TO SELECT MORE</span></p>
        </div>
      </div>
      <!-- Step 3: Uploading File -->
      <div
        class="upload-container__upload-box"
        v-else-if="uploadStage == 'UPLOADING_FILE'"
      >
        <div class="loader__spin"></div>
        <h3>UPLOADING IMAGES</h3>
        <p>THIS MAY TAKE A MOMENT</p>
      </div>
      <!-- Step 4: Uploaded File -->
      <div
        class="upload-container__upload-box"
        v-else-if="uploadStage == 'UPLOADED_FILE'"
      >
        <v-icon
          class="successIcon"
          name="check-circle"
          scale="5"
          color="#48B9BA"
        ></v-icon>
        <h3>IMAGE SUCCESSFULLY UPLOADED</h3>
        <p>YOU MAY NOW CLOSE THIS WINDOW</p>
      </div>

      <div
        class="upload-container__button-container"
        v-if="uploadStage == 'SELECT_FILE' || uploadStage == 'SELECTED_FILE'"
      >
        <div class="button-container">
          <button class="button-neutral" @click="closeUploadMedia">
            CANCEL
          </button>
          <button
            class="button-positive"
            @click="uploadToStorage"
            :disabled="imageFile.length == 0"
          >
            UPLOAD
          </button>
        </div>
      </div>
      <div
        class="upload-container__button-container button-container"
        v-else-if="uploadStage == 'UPLOADED_FILE'"
      >
        <button class="button-neutral" @click="closeUploadMedia">CLOSE</button>
      </div>
    </div>
  </section>
</template>

<script>
import { db, storage } from "@/firebase.js";

export default {
  data() {
    return {
      imageFile: [],
      uploadPercentages: [],
      uploadStage: "SELECT_FILE",
      uploadSuccessModal: false,
      uploadPromises: [],
    };
  },
  methods: {
    selectFile() {
      this.$refs.fileInput.click();
    },
    onFileDropped(event) {
      this.uploadStage = "SELECTED_FILE";
      const droppedFiles = event.dataTransfer.files;

      if (!droppedFiles) {
        return;
      }

      for (var i = droppedFiles.length - 1; i >= 0; i--) {
        this.imageFile.push(droppedFiles[i]);
      }
    },
    dragNDropHighlight() {
      const DragNDropContainer = document.querySelector(
        ".upload-container__upload-box"
      );
      DragNDropContainer.style.borderColor = "#48B9BA";
    },
    dragNDropUnHighlight() {
      const DragNDropContainer = document.querySelector(
        ".upload-container__upload-box"
      );
      DragNDropContainer.style.borderColor = "";
    },
    onFileSelected(event) {
      this.uploadStage = "SELECTED_FILE";

      const files = event.target.files;
      for (var i = files.length - 1; i >= 0; i--) {
        this.imageFile.push(files[i]);
      }
    },
    uploadToStorage() {
      this.uploadStage = "UPLOADING_FILE";

      this.imageFile.forEach((img) => {
        const imageName = img.name;
        const imageNameSplit = img.name.split(".");
        const imageFileType = imageNameSplit[imageNameSplit.length - 1]; // In case of more than one '.', use the last

        // Firebase id (key)
        const key = db.ref(`images/${this.$customerId}/${this.$hotelId}`).push().key;

        const storageRef = storage.ref(
          this.$hotelId + "/" + key + "." + imageFileType
        );

        let uploadTask = storageRef.put(img);
        this.uploadPromises.push(uploadTask);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log(progress);
          },
          (error) => {
            console.log(error);
          },
          () => {
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then(async (downloadURL) => {
                let dataToFirebase = {};
                dataToFirebase[key] = new Object();
                dataToFirebase[key]["url"] = downloadURL;
                dataToFirebase[key]["imagename"] = key + "." + imageFileType;
                dataToFirebase[key]["imageText"] = imageName;
                dataToFirebase[key]["timestamp"] = new Date().getTime();
                dataToFirebase[key]["uploading"] = true;

                this.uploadPercentages = [];
                this.imageFile = [];

                //TODO multiple upload sometimes fails without timeout
                setTimeout(() => {
                  db.ref(`images/${this.$customerId}/${this.$hotelId}`).update(dataToFirebase);
                }, 1000);
              });
          }
        );
      });
      Promise.all(this.uploadPromises).then(() => {
        this.uploadStage = "UPLOADED_FILE";
      });
    },
    closeUploadMedia() {
      this.uploadPercentages = [];
      this.imageFile = [];
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.successIcon {
  align-self: center;
}

.upload-container {
  width: 560px;
  height: 500px;
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  text-align: center;
}
.upload-container__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -5px; /* Cancel 5px of the padding */
  margin-bottom: 25px;
}
.upload-container__header__wrapper {
  width: 30px;
  height: 30px;
}
.upload-container__header__wrapper img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.upload-container__header h2 {
  font-size: 18px;
  margin: 0;
}
.upload-container__upload-box {
  height: 330px;
  width: 100%;
  border: 4px dashed grey;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.upload-container__upload-box img {
  align-self: center;
  height: 100px;
}
.upload-container__upload-box p,
.upload-container__upload-box h3 {
  margin: 0;
}
.upload-container__upload-box h3 {
  font-size: 24px;
  margin-bottom: 4px;
}
.upload-container__upload-box p {
  font-size: 16px;
}
.upload-container__upload-box p span {
  text-decoration: underline;
  cursor: pointer;
  padding: 4px;
}

.upload-media-modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contentContainer {
  background-color: white;
  width: 500px;
  height: 400px;
  border-radius: 5px;
  border: 4px solid #95989a;
}
.browseFiles {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
  cursor: pointer;
}
.browseFiles > p {
  font-size: 20px;
}
.browseFiles > img {
  width: 120px;
}
.fileListWrapper {
  height: calc(100% - 20px);
}
.fileListWrapper > div.buttonWrap {
  display: flex;
  justify-content: flex-end;
  margin-right: 15px;
}
.fileListItems {
  margin-top: 20px;
  margin-bottom: 20px;
  max-height: 300px;
  overflow-x: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.fileListItems div {
  max-height: 300px;
}
.fileListItems div li {
  text-align: left;
  display: flex;
  align-items: center;
}
.fileNameList {
  margin-left: 5px;
}
.removeImageIcon {
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-right: 10px;
}
.fileProgressBarList {
  margin-right: 30px;
}
progress {
  vertical-align: bottom;
  border: 0;
  background-color: #eee;
  width: 200px;
  border-radius: 20px;
}
progress::-webkit-progress-bar {
  border: 0;
  background-color: #eee;
  width: 200px;
  border-radius: 20px;
}
progress::-webkit-progress-value {
  border: 0;
  background-image: -webkit-linear-gradient(
      -45deg,
      transparent 33%,
      rgba(0, 0, 0, 0.1) 33%,
      rgba(0, 0, 0, 0.1) 66%,
      transparent 66%
    ),
    -webkit-linear-gradient(top, rgba(255, 255, 255, 0.25), rgba(0, 0, 0, 0.25)),
    -webkit-linear-gradient(left, #48b9b2, #7e609d);
  border-radius: 2px;
  border-radius: 20px;
}
progress::-moz-progress-bar {
  border: 0;
  border-radius: 20px;
}
.progressPercentage {
  margin-left: 20px;
}
.imageControls {
  position: absolute;
  top: 30px;
  right: 15px;
}
.imageControls > div {
  width: 60px;
  height: 60px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.imageControls > div > img {
  width: 30px;
  height: 30px;
}

.loader__spin {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  animation: spin 1s cubic-bezier(0.15, 0.4, 0.6, 0.3) infinite;
  border: 8px solid #f2f2f2;
  border-top: 8px solid #48b9ba;
  margin: 0 auto 16px auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
